import NotificationsList from "./NotificationsList";

export { NotificationsList as default };
